<template>
  <div style="padding: 10px">
    <el-button type="primary" @click="openEditMailTemplateDialog(true)"
      >添加模板</el-button
    >
    <el-table
      :data="mailTemplateTableData"
      height="700"
      border
      size="small"
      style="width: 700px; margin-top: 10px"
    >
      <el-table-column
        prop="name"
        label="名称（不会在游戏里展示，可当作备注）"
        align="center"
        width="300"
      >
      </el-table-column>
      <el-table-column label="标题和正文" align="center" width="150">
        <template scope="scope">
          <el-popover placement="right" trigger="hover" width="600">
            <div>
              <el-tabs type="card" v-model="scope.row.activeLanguageTabName">
                <el-tab-pane
                  v-for="item in scope.row.languageTemplates"
                  :key="item.languageId"
                  :name="item.languageId"
                >
                  <span slot="label"
                    ><i
                      v-if="item.title.trim() == ''"
                      class="el-icon-info"
                      style="margin-right: 5px; color: red"
                    ></i
                    >{{ `${item.languageName}` }}</span
                  >
                  <div>
                    <label style="display: block">标题：</label>
                    <el-input v-model="item.title" readonly></el-input>
                  </div>
                  <div style="margin-top: 5px">
                    <label style="display: block">正文：</label>
                    <el-input
                      type="textarea"
                      rows="15"
                      v-model="item.content"
                      readonly
                    ></el-input>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <el-button slot="reference" size="small" icon="el-icon-search"
              >查看</el-button
            >
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="250">
        <template scope="scope">
          <el-button
            size="small"
            icon="el-icon-edit"
            @click="openEditMailTemplateDialog(false, scope.row)"
            >修改模板</el-button
          >
          <el-button
            type="primary"
            size="small"
            icon="el-icon-s-promotion"
            @click="openSendMailDialog(scope.row)"
            >发送邮件</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- “添加邮件模板”对话框 -->
    <EditMailTemplateDialog
      v-if="shouldEditTemplateDialogVisible"
      @close="onEditMailTemplateDialogClosed()"
      :value="valueForEditMailTemplateDialog"
    ></EditMailTemplateDialog>

    <!-- “发送邮件”对话框 -->
    <SendMailDialog
      v-if="shouldSendMailDialogVisible"
      @close="onSendMailDialogClosed()"
      :value="dataForSendMailDialog"
    ></SendMailDialog>
  </div>
</template>

<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";

import EditMailTemplateDialog from "./EditMailTemplateDialog";
import SendMailDialog from "./SendMailDialog";
import ChannelSelector from "../../components/ChannelSelector";

export default {
  data() {
    return {
      shouldEditTemplateDialogVisible: false, // “添加邮件模板”对话框是否应该显示出来
      shouldSendMailDialogVisible: false, // “发送邮件”对话框是否应该显示出来
      valueForEditMailTemplateDialog: null, // 要传递给“添加邮件模板”对话框的数据
      mailTemplateTableData: [], // 邮件模板列表里展示的数据
      dataForSendMailDialog: null, // 要传递给“发送邮件”对话框的数据
      availableLanguages: [], // 多语言集合
    };
  },

  components: {
    EditMailTemplateDialog,
    SendMailDialog,
    ChannelSelector,
  },

  async created() {
    // 查询多语言集合
    await this.getLanguageList();

    // 拉取邮件模板集合
    await this.loadMailTemplateList();
  },

  methods: {
    /**
     * 查询邮件模板集合
     */
    async loadMailTemplateList() {
      // 清空表格数据
      this.mailTemplateTableData = [];

      // 向服务器查询模板集合
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/mail/getTemplateList`,
          {
            offset: 1,
            limit: 1000,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        // 可能需要重新登录
        if (resData.code == 2004) {
          util.gotoLoginPage();
          return;
        }

        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let mailTemplateListInResponse = resData.data.templates || [];

      for (let mailTemplateInResponse of mailTemplateListInResponse) {
        let languageTemplates = [];

        for (let language of this.availableLanguages) {
          let title = "";
          let content = "";

          for (let languageTemplateInResponse of mailTemplateInResponse.templates) {
            if (languageTemplateInResponse.language == language.id) {
              title = languageTemplateInResponse.title;
              content = languageTemplateInResponse.text;
              break;
            }
          }

          languageTemplates.push({
            languageId: language.id,
            languageName: language.name,
            title: title,
            content: content,
          });
        }

        this.mailTemplateTableData.push({
          id: mailTemplateInResponse.id,
          name: mailTemplateInResponse.name,
          languageTemplates: languageTemplates,
          activeLanguageTabName: this.availableLanguages[0].id,
        });
      }

      // 排序（按模板被创建的顺序倒序排列）
      this.mailTemplateTableData.sort((x, y) => {
        return Number(y.mailTemplateId) - Number(x.mailTemplateId);
      });
    },

    /**
     * 打开“添加邮件模板”对话框
     */
    async openEditMailTemplateDialog(isCreate, templateData) {
      this.shouldEditTemplateDialogVisible = true;
      this.valueForEditMailTemplateDialog = {
        isCreate: isCreate,
        templateData: templateData,
      };
    },

    /**
     * “添加邮件模板”对话框关闭了
     */
    async onEditMailTemplateDialogClosed() {
      this.shouldEditTemplateDialogVisible = false;

      // 重新拉取邮件模板集合
      return this.loadMailTemplateList();
    },

    /**
     * 打开“发送邮件”对话框
     */
    async openSendMailDialog(templateData) {
      this.shouldSendMailDialogVisible = true;
      this.dataForSendMailDialog = {
        mailTemplate: templateData,
      };
    },

    /**
     * “发送邮件”对话框关闭了
     */
    async onSendMailDialogClosed() {
      this.shouldSendMailDialogVisible = false;
    },

    /**
     * 查询多语言集合
     */
    async getLanguageList() {
      var resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/language/getList`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      if (resData.data.languages) {
        for (let l of resData.data.languages) {
          this.availableLanguages.push(l);
        }
      }
    },
  },
};
</script>